export class TabNameReq{
    tabName : string;

    constructor(tabName:string){
        this.tabName = tabName
    }
}